import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exceptional-coefficients',
  templateUrl: './exceptional-coefficients.component.html',
  styleUrls: ['./exceptional-coefficients.component.css']
})
export class ExceptionalCoefficientsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
